var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.85983 6.26516C3.71339 6.11872 3.71339 5.88128 3.85983 5.73484L7.60984 1.98483C7.75628 1.83839 7.99372 1.83839 8.14016 1.98483C8.28661 2.13128 8.28661 2.36872 8.14016 2.51517L4.65533 6L8.14016 9.48484C8.28661 9.63128 8.28661 9.86872 8.14016 10.0152C7.99372 10.1616 7.75628 10.1616 7.60984 10.0152L3.85983 6.26516Z",
    fill: "#010F55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/ChevronLeft.6ef580834d6fbe7d0f932107e3b4bf52.svg";
export { ForwardRef as ReactComponent };